import React from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

const Container = styled(Box)({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '360px',
  backgroundColor: '#fff',
  borderRadius: '8px',
  overflow: 'hidden',
  outline: 'none',
});

const Header = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  height: '48px',
  padding: '0 24px',
  backgroundColor: '#262626',
});

const Title = styled(Typography)({ fontSize: '16px', fontWeight: 600, color: '#fff' });

const Body = styled(Box)({ padding: '24px', backgroundColor: '#fafbfc' });

const Message = styled(Typography)({ fontSize: '14px', lineHeight: 1.6, color: '#4D4D4D', whiteSpace: 'pre-line' });

const Footer = styled(Box)({ display: 'flex', gap: '8px', padding: '0 24px 20px', backgroundColor: '#fafbfc' });

const CancelButton = styled(Button)({
  flex: 1,
  height: '44px',
  borderRadius: '8px',
  backgroundColor: '#E6E6E6',
  color: '#666',
  fontSize: '15px',
  fontWeight: 600,
  textTransform: 'none',
});

const ConfirmButton = styled(Button, { shouldForwardProp: p => p !== 'danger' })(({ danger }) => ({
  flex: 1,
  height: '44px',
  borderRadius: '8px',
  backgroundColor: danger ? '#E53935' : '#4ab3bc',
  color: '#fff',
  fontSize: '15px',
  fontWeight: 600,
  textTransform: 'none',
  '&:hover': { backgroundColor: danger ? '#C62828' : '#3a9aa2' },
  '&.Mui-disabled': { opacity: 0.5, color: '#fff' },
}));

/**
 * ConfirmDialog - 시설제어 공용 확인 모달 (다른 모달과 같은 검정 헤더 디자인)
 */
const ConfirmDialog = ({ open, title, message, confirmText, danger = false, isPending = false, onCancel, onConfirm }) => {
  const { t } = useTranslation();
  return (
    <Modal open={open} onClose={isPending ? undefined : onCancel}>
      <Container>
        <Header>
          <Title>{title}</Title>
        </Header>
        <Body>
          <Message>{message}</Message>
        </Body>
        <Footer>
          <CancelButton disabled={isPending} onClick={onCancel}>
            {t('취소')}
          </CancelButton>
          <ConfirmButton danger={danger} disabled={isPending} onClick={onConfirm}>
            {isPending ? t('처리 중...') : confirmText || t('확인')}
          </ConfirmButton>
        </Footer>
      </Container>
    </Modal>
  );
};

export default ConfirmDialog;
